import { render, staticRenderFns } from "./RollerBrakeTesterMC.vue?vue&type=template&id=12f61dba&scoped=true&"
import script from "./RollerBrakeTesterMC.vue?vue&type=script&lang=js&"
export * from "./RollerBrakeTesterMC.vue?vue&type=script&lang=js&"
import style0 from "./RollerBrakeTesterMC.vue?vue&type=style&index=0&id=12f61dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f61dba",
  null
  
)

export default component.exports